import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-app-loader',
    imports: [CommonModule],
    templateUrl: './app-loader.component.html',
    styleUrl: './app-loader.component.scss'
})
export class AppLoaderComponent {

}
